module.exports = __webpack_public_path__ + "img/sprinkle-13.bef9a7eb.jpg";